<main [style.background]="backgroundColor()">
  <img src="assets/huro-logo.svg" alt="Huro Logo" />
</main>
